export default __webpack_public_path__ + "static/media/reload_promotion.26aa4c22.png";